import { useMessageSource } from "react-message-source";
import { useFormatNumber } from "../../shared/hooks/useFormatNumber";
import { AnnualGrossIncome } from "./types";

interface AnnualGrossIncomeValueType {
  id: string;
  value: AnnualGrossIncome;
  label: string;
}

export default function useAnnualGrossIncomeValues(
  dataPath: string,
): AnnualGrossIncomeValueType[] {
  const { getMessage } = useMessageSource();
  const { formatStringAsAmount } = useFormatNumber();

  return [
    {
      id: `${dataPath}${AnnualGrossIncome.LESS_THAN_50_000}`,
      value: AnnualGrossIncome.LESS_THAN_50_000,
      label: getMessage("ValueRange.lessThan", formatStringAsAmount("50000")),
    },
    {
      id: `${dataPath}${AnnualGrossIncome.BETWEEN_50_000_AND_100_0000}`,
      value: AnnualGrossIncome.BETWEEN_50_000_AND_100_0000,
      label: getMessage(
        "ValueRange.between",
        formatStringAsAmount("50000"),
        formatStringAsAmount("100000"),
      ),
    },
    {
      id: `${dataPath}${AnnualGrossIncome.BETWEEN_100_000_AND_150_0000}`,
      value: AnnualGrossIncome.BETWEEN_100_000_AND_150_0000,
      label: getMessage(
        "ValueRange.between",
        formatStringAsAmount("100001"),
        formatStringAsAmount("150000"),
      ),
    },

    {
      id: `${dataPath}${AnnualGrossIncome.OVER_150_000}`,
      value: AnnualGrossIncome.OVER_150_000,
      label: getMessage(
        "ValueRange.greaterThan",
        formatStringAsAmount("150000"),
      ),
    },
  ];
}
